import React from 'react';

const PageLayout = ({children}) =>
        <div className="mdl-layout__tab-panel">
                {children}
        </div>;

export default PageLayout;